export function getClientOriginUrl() {
  return window.location.origin;
}

export function getCookie(name) {
  const cookie = document.cookie.split(';').find(c => {
    return c.trim().startsWith(encodeURIComponent(name) + '=');
  });
  const idx = cookie && cookie.indexOf('=');
  return idx ? decodeURIComponent(cookie.substr(idx + 1)) : undefined;
}

export function setCookie(name, value) {
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(
    value
  )};path=/`;
}

export function deleteCookie(name, domain = 'mongodb.com') {
  document.cookie = `${encodeURIComponent(name)}=;domain=.${encodeURIComponent(
    domain
  )};expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
}

export function setLocalStorage(name, value) {
  window.localStorage.setItem(name, value);
}

export function getLocalStorage(name) {
  return window.localStorage.getItem(name);
}

export function setWindowTitle(name) {
  window.document.title = name;
}

export function fetchResource(...args) {
  return fetch.apply(null, args);
}

export function isMac() {
  return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
}
